import React from 'react';
import styles from './FormTitle.module.css';
import { BackButton } from '../CtaButton/BackButton';
import { FormTitleProps } from './types';

export const FormTitle = ({
    formTitleText,
    dataViewLabel,
    dataClickLabel,
}: FormTitleProps) => {
    return (
        <div className={styles.content}>
            <BackButton dataClickLabel={dataClickLabel} />
            <div className={styles.title}>
                <h1
                    className={styles.titleText}
                    data-view-label={dataViewLabel}
                >
                    {formTitleText}
                </h1>
            </div>
        </div>
    );
};
